<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="isSmallScreen ? '30px' : '24px'" :height="isSmallScreen ? '30px' : '24px'" viewBox="0 0 24 24" fill="none" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-layout-dashboard-icon lucide-layout-dashboard">
    <rect width="7" height="9" x="3" y="3" rx="1"/><rect width="7" height="5" x="14" y="3" rx="1"/>
    <rect width="7" height="9" x="14" y="12" rx="1"/>
    <rect width="7" height="5" x="3" y="16" rx="1"/></svg>
</template>
<script lang="ts">
import {useScreenSize} from "@/composable/useScreenSize.js";
import {useCommonStore} from "@/stores/common";
import {ref, watch} from "vue";
export default {
  name: 'IconDashboard',
  setup() {
    const { width, isSmallScreen } = useScreenSize(1024);
    const commonStore = useCommonStore()
    const color = ref('#3a3a3a')
    watch(() => (commonStore.settings.icons as Record<string, boolean>)?.['IconDashboard'], (newStatus) => {
      color.value = newStatus ? '#3cc89e' : '#3a3a3a'
    });
    return {
      width,
      color,
      isSmallScreen,
    }
  }
}
</script>